export default __webpack_public_path__ + "static/media/tablet-background-img-min.344b8897.png";